module.exports = __webpack_public_path__ + "assets/img/typeIcon-3-red.d972c8fe.svg";